/**
 * Single source for the indicative monthly payment shown on listing cards
 * ("Credit de la X €/lună") and in the listing-page calculator. Amounts are EUR.
 */
export const FINANCING_DEFAULTS = {
  /** Annual interest rate shown in the calculator disclaimer. */
  apr: 0.065,
  /** Default down payment, percent of price. */
  downPct: 20,
  /** Default period in months. */
  months: 60,
} as const;

export function monthlyPaymentEur(
  priceEur: number,
  downPct: number = FINANCING_DEFAULTS.downPct,
  months: number = FINANCING_DEFAULTS.months,
  apr: number = FINANCING_DEFAULTS.apr,
): number {
  const principal = priceEur * (1 - downPct / 100);
  if (!(principal > 0) || !(months > 0)) return 0;
  const r = apr / 12;
  if (r === 0) return principal / months;
  return (principal * r) / (1 - Math.pow(1 + r, -months));
}
